<template>
	<div>
		<div
			v-for="(comment, index) in comments"
			class="card mb-3 border-0 bg-light"
			:key="'comment_' + index"
		>
			<div class="card-body p-3">
				<div class="d-flex">
					<img
						src="@/assets/images/logo.png"
						alt="User"
						class="rounded-circle me-3"
						width="60"
						height="60"
					/>
					<div class="flex-grow-1">
						<div class="d-flex justify-content-between mb-1">
							<div>
								<strong>{{ comment.creator.name }}</strong>
								<small class="text-muted ms-2"
									>({{ comment.creator.designation }})</small
								>
							</div>
							<div>
								<small class="text-muted"
									><i class="fas fa-clock text-warning"></i>
									{{ comment.created_at }}</small
								>
								<br />
								<span
									v-if="comment.status == 'Approved'"
									class="badge bg-success"
									>Verified</span
								>
								<span v-else class="badge bg-danger">{{ comment.status }}</span>
							</div>
						</div>
						<p
							class="mb-2"
							v-html="comment.comment ? comment.comment : 'Section verified'"
						></p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		comments: {
			type: Array,
		},
	},
};
</script>
